document.addEventListener('alpine:init', () => {
  Alpine.data('footer', () => ({
    get visiblePopup() {
      return this._visiblePopup;
    },
    set visiblePopup(value) {
      if (value !== this._visiblePopup) {
        this._visiblePopup = value;

        if (value) {
          this.$store.bottomSheet.open('light');
        } else {
          this.$store.bottomSheet.close();
        }
      }
    },
    _visiblePopup: null,
  }));
});